import moment from 'moment';

const STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguardando material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguardando validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

const TIPO_LABELS = {
  CORRETIVA: 'Corretiva',
  PREVENTIVA: 'Preventiva',
  IMPLANTACAO: 'Implantação',
  RECLAMACAO: 'Reclamação',
};

const PRIORIDADE_LABELS = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  CRITICA: 'Crítica',
};

const COLUNAS = [
  { key: 'numero', label: 'Número' },
  { key: 'titulo', label: 'Título' },
  { key: 'tipo', label: 'Tipo' },
  { key: 'status', label: 'Status' },
  { key: 'prioridade', label: 'Prioridade' },
  { key: 'grupo_fisico_descricao', label: 'Grupo Físico' },
  { key: 'cruzamento', label: 'Cruzamento' },
  { key: 'controlador_numero', label: 'Controlador' },
  { key: 'equipe_nome', label: 'Equipe' },
  { key: 'nome_usuario_responsavel', label: 'Responsável' },
  { key: 'nome_usuario_abertura', label: 'Usuário abertura' },
  { key: 'data_abertura', label: 'Data abertura' },
  { key: 'data_prazo', label: 'Data prazo' },
  { key: 'sla_horas', label: 'SLA (h)' },
  { key: 'descricao', label: 'Descrição' },
  { key: 'ultima_interacao_texto', label: 'Última interação' },
];

function escaparCelula(valor) {
  if ((valor === null || valor === undefined)) return '';
  const texto = String(valor).replace(/\r?\n/g, ' ').trim();
  if (/[;"\n]/.test(texto)) {
    return `"${texto.replace(/"/g, '""')}"`;
  }
  return texto;
}

function formatarValor(os, key) {
  switch (key) {
    case 'tipo':
      return TIPO_LABELS[os.tipo] || os.tipo || '';
    case 'status':
      return STATUS_LABELS[os.status] || os.status || '';
    case 'prioridade':
      return PRIORIDADE_LABELS[os.prioridade] || os.prioridade || '';
    case 'data_abertura':
    case 'data_prazo':
      return os[key] ? moment(os[key]).format('DD/MM/YYYY HH:mm') : '';
    case 'cruzamento':
      return os.cruzamento || (os.controlador_numero ? `Ctrl ${os.controlador_numero}` : '');
    default:
      return (os[key] !== null && os[key] !== undefined) ? os[key] : '';
  }
}

function escaparHtml(texto) {
  if ((texto === null || texto === undefined)) return '';
  return String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function exportarOrdensServicoExcel(ordens, nomeArquivo) {
  const linhas = [
    COLUNAS.map(c => escaparCelula(c.label)).join(';'),
    ...ordens.map(os => COLUNAS.map(c => escaparCelula(formatarValor(os, c.key))).join(';')),
  ];

  const conteudo = `\uFEFF${linhas.join('\r\n')}`;
  const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  const dataStamp = moment().format('YYYYMMDD_HHmm');
  link.href = url;
  link.download = nomeArquivo || `ordens_servico_${dataStamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function imprimirOrdensServicoPdf(ordens, resumoFiltros = '') {
  const linhasTabela = ordens
    .map(
      os =>
        `<tr>${COLUNAS.map(c => `<td>${escaparHtml(formatarValor(os, c.key))}</td>`).join('')}</tr>`,
    )
    .join('');

  const html = `
    <html>
      <head>
        <title>Relatório de Ordens de Serviço</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #333; font-size: 11px; }
          .header { margin-bottom: 20px; border-bottom: 2px solid #3c8dbc; padding-bottom: 10px; }
          .header h2 { margin: 0 0 8px; color: #2d3748; font-size: 18px; }
          .header p { margin: 4px 0; color: #64748b; }
          table { width: 100%; border-collapse: collapse; margin-top: 12px; }
          th, td { border: 1px solid #ddd; padding: 6px 8px; text-align: left; vertical-align: top; }
          th { background: #f1f5f9; color: #475569; font-size: 10px; text-transform: uppercase; }
          tr:nth-child(even) { background: #f8fafc; }
          @media print {
            body { margin: 10px; }
            table { font-size: 9px; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>Relatório de Ordens de Serviço</h2>
          <p><strong>Gerado em:</strong> ${moment().format('DD/MM/YYYY HH:mm')}</p>
          <p><strong>Total de registros:</strong> ${ordens.length}</p>
          ${resumoFiltros ? `<p><strong>Filtros:</strong> ${escaparHtml(resumoFiltros)}</p>` : ''}
        </div>
        <table>
          <thead>
            <tr>${COLUNAS.map(c => `<th>${c.label}</th>`).join('')}</tr>
          </thead>
          <tbody>${linhasTabela}</tbody>
        </table>
      </body>
    </html>
  `;

  const janela = window.open('', '', 'width=1100,height=700');
  janela.document.open();
  janela.document.write(html);
  janela.document.close();
  janela.focus();
  janela.print();
  janela.close();
}
